export const apiEndpoints = {
  // Pickems
  pickems: '/pickems',
  getPickems: '/pickems',
  createPickem: '/pickems',
  getPickemById: (pickemId: string) => `/pickems/${pickemId}`,
  updatePickem: (pickemId: string) => `/pickems/${pickemId}`,
  deletePickem: (pickemId: string) => `/pickems/${pickemId}`,
  completePickem: (pickemId: string) => `/pickems/${pickemId}/complete`,
  markAsPaidOut: (pickemId: string) => `/pickems/${pickemId}/mark-paid-out`,
  forcePickemScoring: (pickemId: string) => `/pickems/${pickemId}/force-leaderboard-scoring`,
  startScoringAsync: (pickemId: string) => `/pickems/${pickemId}/start-scoring`,
  scoringStream: (pickemId: string) => `/pickems/${pickemId}/scoring-stream`,
  scoringStatus: '/pickems/scoring/status',
  startGradingAsync: (pickemId: string) => `/pickems/${pickemId}/start-grading`,
  recalculatePickemRanks: (pickemId: string) => `/pickems/${pickemId}/recalculate-ranks`,
  getPickemEntries: (pickemId: string) => `/pickems/${pickemId}/entries`,
  getPickemUserSelections: (pickemId: string, userId: string) =>
    `/pickems/${pickemId}/users/${userId}/selections`,

  // Questions
  questions: '/questions',
  getQuestions: '/questions',
  createQuestion: '/questions',
  updateQuestion: (pickemId: string) => `/pickems/${pickemId}/questions`,
  updateQuestionCorrectValue: (questionId: string) => `/questions/${questionId}/correct-value`,
  reorderQuestions: (pickemId: string) => `/pickems/${pickemId}/questions/reorder`,

  // Tenants
  tenants: '/tenants',
  getTenants: '/tenants',
  createTenant: '/tenants',
  updateTenant: (tenantId: string) => `/tenants/${tenantId}`,
  deleteTenant: (tenantId: string) => `/tenants/${tenantId}`,

  // Leaderboard
  getPickemLeaderboard: (pickemId: string) => `/leaderboard/pickems/${pickemId}`,

  // Settings
  getSports: '/settings/sports',
  updateStatus: (settingsKey: string, id: string) => `/settings/${settingsKey}/${id}/status`,

  // Translation
  translate: '/translate',

  // Dev Data
  deleteAllPickems: '/dev-data/pickems',
  generatePickems: '/dev-data/generate-pickems',
  createDemoPickem: '/dev-data/create-demo-pickem',
  flushCache: '/dev-data/flush-cache',
  regenerateAggregateLeaderboards: '/aggregate-leaderboard/regenerate',
  redisHealth: '/dev-data/redis/health',
  redisKeys: '/dev-data/redis/keys',
  redisValue: '/dev-data/redis/value',
  eventStreamPreview: '/dev-data/event-stream-preview',
  bustDailyRevealCache: '/dev-data/bust-daily-reveal-cache',
} as const;
